const eShopAPI = {

  fetchValues: {
    endPoints: {
      onVATchange: "aHR0cHM6Ly94OGdxLW1mbzUtcWM1aC5mMi54YW5vLmlvL2FwaTpUZTJ6WDR2Yi9jdXN0b21lci9vbi12YXQtY2hhbmdl",
      restockAlertCreate: "aHR0cHM6Ly94OGdxLW1mbzUtcWM1aC5mMi54YW5vLmlvL2FwaTpUZTJ6WDR2Yi9yZXN0b2NrLWFsZXJ0L2NyZWF0ZQ=="
    },
    params: {
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Shop-Domain": window.permanent_domain,
        "X-Shopify-Access-Token": "MnNxazlzOThhYWo5cjE0Y3poN3Vmc2szb2xscHF0b2VmaHVla3lkazl6YzZmN3l6bGw0NmJ2ZGpnbzB6b2Rtbw=="
      },
      redirect: "follow",
      referrerPolicy: "no-referrer"
    }
  },

  fetchURL: async function (url, method, body, onSuccess, onError) {
    this.fetchValues.params.method = method;
    if (!body) delete this.params.body;
    else this.fetchValues.params.body =  JSON.stringify (body);
    try {
      const response = await fetch ($.base64.decode (url), this.fetchValues.params);
      if (response.ok) {
        const json = await response.json();
        onSuccess (json);
      } else {
        const json = await response.json();
        onError (response, json);
        throw new Error(`Response status: ${response.status}`);
      }
    } catch (error) {
      console.log (error);
    }
  },

  onVATchange: {
    sendData: function (customerId, value) {
      if (!customerId) return;
      let data = {
        customer_id: customerId,
        show_tax_value: value
      };
      eShopAPI.fetchURL (eShopAPI.fetchValues.endPoints.onVATchange, "POST", data, this.onSuccess, this.onError);
    },
    onSuccess: function (response) {
      console.log (response);
    },
    onError: function (error, body) {
      console.log (error);
    }
  }
  
};